import config from '../config'
import { Auth } from 'aws-amplify'

const AmplifyConfiguration =
  {
    AuthPasswordFree: {
      mandatorySignIn: false,
      region: config.Cognito.Region,
      userPoolId: config.Cognito.PwdFreeUserPoolId,
      identityPoolId: config.Cognito.IdentityPoolId,
      userPoolWebClientId: config.Cognito.PwdFreeAppClientId,
      identityPoolRegion: config.Cognito.Region,
      oauth: {
        domain: config.Cognito.Domain,
        scope: ['email', 'openid'],
        redirectSignIn: config.Cognito.RedirectSignIn,
        redirectSignOut: config.Cognito.RedirectSignOut,
        responseType: config.Cognito.OauthResponseType
      }

    },
    Auth: {
      mandatorySignIn: true,
      region: config.Cognito.Region,
      userPoolId: config.Cognito.UserPoolId,
      identityPoolId: config.Cognito.IdentityPoolId,
      userPoolWebClientId: config.Cognito.AppClientId,
      identityPoolRegion: config.Cognito.Region,
      oauth: {
        domain: config.Cognito.Domain,
        scope: ['email', 'openid'],
        redirectSignIn: config.Cognito.RedirectSignIn,
        redirectSignOut: config.Cognito.RedirectSignOut,
        responseType: config.Cognito.OauthResponseType
      }
    },
    API: {
      endpoints: [
        {
          name: "log-error",
          endpoint: config.ApiGateway.Endpoint + "error/log",
          region: "eu-west-1",
        },
        {
          name: "show-create",
          endpoint: config.ApiGateway.Endpoint + "show/create",
          region: "eu-west-1",
          custom_header: async () => {
            return { Authorization: (await Auth.currentSession()).idToken.jwtToken }
          }
        },
        {
          name: "show-delete",
          endpoint: config.ApiGateway.Endpoint + "show/delete",
          region: "eu-west-1",
          custom_header: async () => {
            return { Authorization: (await Auth.currentSession()).idToken.jwtToken }
          }
        },
        {
          name: "show-request",
          endpoint: config.ApiGateway.Endpoint + "show/request",
          region: "eu-west-1",
        },
        {
          name: "place-create",
          endpoint: config.ApiGateway.Endpoint + "place/create",
          region: "eu-west-1",
          custom_header: async () => {
            return { Authorization: (await Auth.currentSession()).idToken.jwtToken }
          }
        },
        {
          name: "place-delete",
          endpoint: config.ApiGateway.Endpoint + "place/delete",
          region: "eu-west-1",
          custom_header: async () => {
            return { Authorization: (await Auth.currentSession()).idToken.jwtToken }
          }
        },
        {
          name: "place-request",
          endpoint: config.ApiGateway.Endpoint + "place/request",
          region: "eu-west-1",
        },
        {
          name: "place-seats-request",
          endpoint: config.ApiGateway.Endpoint + "place/seats/request",
          region: "eu-west-1",
        },
        {
          name: "performance-create",
          endpoint: config.ApiGateway.Endpoint + "performance/create",
          region: "eu-west-1",
          custom_header: async () => {
            return { Authorization: (await Auth.currentSession()).idToken.jwtToken }
          }
        },
        {
          name: "performance-delete",
          endpoint: config.ApiGateway.Endpoint + "performance/delete",
          region: "eu-west-1",
          custom_header: async () => {
            return { Authorization: (await Auth.currentSession()).idToken.jwtToken }
          }
        },
        {
          name: "performance-cancel",
          endpoint: config.ApiGateway.Endpoint + "performance/cancel",
          region: "eu-west-1",
          custom_header: async () => {
            return { Authorization: (await Auth.currentSession()).idToken.jwtToken }
          }
        },
        {
          name: "performance-setadmin",
          endpoint: config.ApiGateway.Endpoint + "performance/setadmin",
          region: "eu-west-1",
          custom_header: async () => {
            return { Authorization: (await Auth.currentSession()).idToken.jwtToken }
          }
        },
        {
          name: "performance-query",
          endpoint: config.ApiGateway.Endpoint + "performance/query",
          region: "eu-west-1",
        },
        {
          name: "performance-retrieve",
          endpoint: config.ApiGateway.Endpoint + "performance/retrieve",
          region: "eu-west-1",
        },
        {
          name: "performance-seats-retrieve",
          endpoint: config.ApiGateway.Endpoint + "performance/seats/retrieve",
          region: "eu-west-1",
        },
        {
          name: "booking-create",
          endpoint: config.ApiGateway.Endpoint + "booking/create",
          region: "eu-west-1",
          custom_header: async () => {
            return { Authorization: (await Auth.currentSession()).idToken.jwtToken }
          }
        },
        {
          name: "booking-confirm",
          endpoint: config.ApiGateway.Endpoint + "booking/confirm",
          region: "eu-west-1",
          custom_header: async () => {
            return { Authorization: (await Auth.currentSession()).idToken.jwtToken }
          }
        },
        {
          name: "booking-cancel",
          endpoint: config.ApiGateway.Endpoint + "booking/cancel",
          region: "eu-west-1",
          custom_header: async () => {
            return { Authorization: (await Auth.currentSession()).idToken.jwtToken }
          }
        },
        {
          name: "booking-comment",
          endpoint: config.ApiGateway.Endpoint + "booking/comment",
          region: "eu-west-1",
          custom_header: async () => {
            return { Authorization: (await Auth.currentSession()).idToken.jwtToken }
          }
        },
        {
          name: "booking-query",
          endpoint: config.ApiGateway.Endpoint + "booking/query",
          region: "eu-west-1",
          custom_header: async () => {
            return { Authorization: (await Auth.currentSession()).idToken.jwtToken }
          }
        },
        {
          name: "booking-retrieve",
          endpoint: config.ApiGateway.Endpoint + "booking/retrieve",
          region: "eu-west-1",
          custom_header: async () => {
            return { Authorization: (await Auth.currentSession()).idToken.jwtToken }
          }
        },
        {
          name: "report-request",
          endpoint: config.ApiGateway.Endpoint + "report/request",
          region: "eu-west-1",
          custom_header: async () => {
            return { Authorization: (await Auth.currentSession()).idToken.jwtToken }
          }
        }

      ]
    }
  }

export default AmplifyConfiguration;